import { CapsuleModal } from '@components/hub/capsules/CapsuleModal';
import { FancyCard } from '@components/ui/FancyCard';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useCapsulesQuery } from '@http';
import * as Shared from '@shared/lib';
import { useAppStore } from '@stores';

export function Capsules() {
  const [renderCount, setRenderCount] = useState(0);
  const [showAdd, setShowAdd] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Capsules' });
  const { data: activeCapsules } = useCapsulesQuery();
  const { userData } = useAppStore();

  useEffect(() => {
    const interval = setInterval(() => {
      setRenderCount(renderCount + 1);
    }, 1000);
    return () => clearInterval(interval);
  });

  const getMinutes = (date: string) => {
    return Math.floor((new Date(date).getTime() - Date.now()) / 60000);
  };

  const getModifier = (type: string) => {
    const data = Shared.capsuleData.find(c => c.type === type);
    if (!data) return '--';

    const similars = activeCapsules?.filter(c => c.type === type);
    if (!similars?.length) return '--';

    const value = ((data.multiplier - 1) * similars.length * 100).toFixed(0);
    return t(`Types.${type}.modifier`, { value });
  };

  const filteredCapsules = activeCapsules?.filter(c => getMinutes(c.endsAt) > 0);
  const activeData = Shared.capsuleData.filter(c => filteredCapsules?.find(f => f.type === c.type));

  if (!userData.tutorials.includes('Inv')) return null;

  return (
    <>
      <CapsuleModal onClose={() => setShowAdd(false)} open={showAdd} />

      <div className="mt-4 px-2 mb-1">
        <p className="text-lg">{t('title')}</p>
      </div>

      {!filteredCapsules?.length && (
        <FancyCard className="border-x-0 border-secondary">
          <button onClick={() => setShowAdd(true)} className="py-6 w-full">
            <p className="text-center text-gray-400 text-sm">{t('noCapsules')}</p>
            <p className="text-center text-xs slight-active">{t('noCapsulesDescription')}</p>
          </button>
        </FancyCard>
      )}

      {!!filteredCapsules?.length && (
        <div className="bg-black/80 border-y border-secondary w-full p-2" onClick={() => setShowAdd(true)}>
          {activeData.map(capsule => (
            <div key={capsule.id} className="mb-2">
              <div className="capsule-outer mb-0">
                <div className="capsule-container">
                  <div className="capsule-img-container grid-overlay">
                    <img src={`/img/capsules/capsule${capsule.id}.avif`} />
                  </div>

                  <div className="ml-2 flex flex-col justify-center text-sm">
                    <p>{t(`Types.${capsule.type}.name`)}</p>
                    <p className="text-primary text-xs">{getModifier(capsule.type)}</p>
                  </div>
                </div>
              </div>

              {filteredCapsules.filter(c => c.type === capsule.type).map((c) => (
                <div className="ml-12 p-1 px-2 btn-active" key={c.id}>
                  <div className="flex justify-between items-center">
                    <p className="text-center text-sm">
                      {c.user.username}
                    </p>
                    <p className="text-center text-sm">
                      {t('minutes', { minutes: getMinutes(c.endsAt) })}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}

          <p className="text-center text-xs active">
            {t('capsulesClick')}
          </p>
        </div>
      )}
    </>
  );
}